// import { gsap } from 'gsap';
// import { ScrollTrigger } from 'gsap/ScrollTrigger';

import 'slick-carousel';
$(function () {
  // AOP slider
  $('.js-aop-slider').each(function () {
    const $slider = $(this);
    const $nav = $slider.next('.aop-slider__nav'); // progress bar container comes AFTER slider
    const $progress = $nav.find('.slider-progress');

    $slider.on(
      'init reInit afterChange',
      function (event, slick, currentSlide) {
        const slideIndex = currentSlide || 0;
        const slidesToShow = slick.options.slidesToShow;

        let i = slideIndex + slidesToShow;
        if (i > slick.slideCount) i = slick.slideCount;

        const percent = (i / slick.slideCount) * 100;

        $progress.css('width', percent + '%');
      }
    );
  });

  $('.js-aop-slider').slick({
    infinite: false,
    slidesToShow: 4,
    slidesToScroll: 1,
    arrows: true,
    dots: false,
    prevArrow: $('.aop-slider__nav .arrow-left'),
    nextArrow: $('.aop-slider__nav .arrow-right'),
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 782,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  });

  // Progress slider
  $('.js-testimonials-slider').each(function () {
    const $slider = $(this);
    const $nav = $slider.next('.testimonials-slider-nav'); // progress bar container comes AFTER slider
    const $progress = $nav.find('.slider-progress');

    $slider.on(
      'init reInit afterChange',
      function (event, slick, currentSlide) {
        const slideIndex = currentSlide || 0;
        const slidesToShow = slick.options.slidesToShow;

        let i = slideIndex + slidesToShow;
        if (i > slick.slideCount) i = slick.slideCount;

        const percent = (i / slick.slideCount) * 100;

        $progress.css('width', percent + '%');
      }
    );
  });

  $('.js-testimonials-slider').slick({
    infinite: false,
    slidesToShow: 3,
    slidesToScroll: 1,
    arrows: true,
    dots: false,
    prevArrow: $('.testimonials-slider-nav .arrow-left'),
    nextArrow: $('.testimonials-slider-nav .arrow-right'),
    responsive: [
      {
        breakpoint: 1025,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 782,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  });

  // const video = $('.video-mobile')[0];
  //
  // $('.video-mobile-play').on('click', function () {
  //   $(this).hide();
  //   video.show();
  //   video.controls = true;
  //   video.play();
  // });
  //
  // $(video).on('pause ended', function () {
  //   $('.video-mobile-play').show();
  // });
  $('.video-mobile-play').on('click', function () {
    const btn = $(this);
    const video = $('.video-mobile')[0]; // keep your existing selector

    // hide the image
    $('.hero-img__mobile').hide();

    // show video and play
    $(video).show();
    $(video).css('height', 'vw-calc(608, 390)');
    video.controls = true;
    video.play();

    btn.hide();

    // show button again on pause or end
    $(video).on('pause ended', function () {
      btn.show();
    });
  });
});

jQuery(function ($) {
  const $texts = $('.about-text__item');
  const $images = $('.about-image');

  function onScroll() {
    let scrollTop = $(window).scrollTop();
    let winHeight = $(window).height();

    $texts.each(function () {
      let $el = $(this);
      let offsetTop = $el.offset().top;
      let height = $el.outerHeight();
      let index = $el.data('index');

      // When text is in middle of viewport
      if (
        scrollTop + winHeight / 2 >= offsetTop &&
        scrollTop + winHeight / 2 < offsetTop + height
      ) {
        $images.removeClass('is-active');
        $images.filter('[data-index="' + index + '"]').addClass('is-active');
      }
    });
  }

  $(window).on('scroll', onScroll);
  onScroll(); // trigger on load
});

// search form
const icon = $('.search-button > a');
const form = $('.header-secrch-form-wrap');
const searchClose = $('.search-close');

icon.on('click', function () {
  form.toggleClass('search-active');
  $('body').toggleClass('body__search-active');
});

searchClose.on('click', function () {
  form.removeClass('search-active');
  $('body').removeClass('body__search-active');
});

$(document).on('click', function (event) {
  if (
    !$(event.target).closest('.header-secrch-form-wrap').length &&
    !$(event.target).closest('.search-button > a').length
  ) {
    $('.header-secrch-form-wrap').removeClass('search-active');
    $('body').removeClass('body__search-active');
  }
});
